module.exports = __webpack_public_path__ + "static/media/2.431f60ac.jpeg";